import script from "./chart5.vue?vue&type=script&lang=ts&setup=true"
export * from "./chart5.vue?vue&type=script&lang=ts&setup=true"

import "./chart5.vue?vue&type=style&index=0&id=59d7ae60&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59d7ae60"]])

export default __exports__